import { render, staticRenderFns } from "./BrickBase.vue?vue&type=template&id=6d2a6cee&"
import script from "./BrickBase.vue?vue&type=script&lang=js&"
export * from "./BrickBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2a6cee')) {
      api.createRecord('6d2a6cee', component.options)
    } else {
      api.reload('6d2a6cee', component.options)
    }
    module.hot.accept("./BrickBase.vue?vue&type=template&id=6d2a6cee&", function () {
      api.rerender('6d2a6cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/BrickBase.vue"
export default component.exports